import { api } from '../api.js';
import { setState } from '../state.js';
import { navigate } from '../router.js';
import { createModal } from '../components/modal.js';
import { translate } from '../lib/i18n.js';

export async function renderAuthView(container: HTMLElement): Promise<void> {
  container.innerHTML = '';

  const { overlay } = createModal({
    title: translate('auth.login_title', 'Welcome back'),
    subtitle: translate('auth.login_subtitle', 'Pick up where you left off.'),
    body: `
      <form id="auth-form">
        <div class="form-group">
          <label class="form-group__label">${translate('auth.email', 'email')}</label>
          <input class="input" type="email" name="email" placeholder="${translate('auth.placeholder_email', 'you@example.com')}" required>
        </div>
        <div class="form-group">
          <label class="form-group__label">${translate('auth.password', 'password')}</label>
          <input class="input" type="password" name="password" placeholder="${translate('auth.placeholder_password', '8+ characters')}" required minlength="8">
        </div>
        <div id="auth-error" class="form-error" style="margin-bottom: 1rem; display: none;"></div>
        <button type="submit" class="btn btn--signal" style="width: 100%;">
          ${translate('auth.login_btn', 'Log in')} &rarr;
        </button>
      </form>
    `,
    onClose: () => navigate('/graph'),
  });

  // Move overlay from document.body into container (auth view renders inline)
  overlay.remove();
  container.appendChild(overlay);

  // Submit
  const form = overlay.querySelector('#auth-form') as HTMLFormElement;
  const errorEl = overlay.querySelector('#auth-error') as HTMLElement;

  form.addEventListener('submit', async (e: Event) => {
    e.preventDefault();
    errorEl.style.display = 'none';

    const formData = new FormData(form);
    const email = formData.get('email') as string;
    const password = formData.get('password') as string;

    try {
      const user = await api.login(email, password);
      setState({ user });
      navigate('/graph');
    } catch (err) {
      errorEl.textContent = (err as Error).message;
      errorEl.style.display = 'block';
    }
  });
}
